import React from 'react'
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import './Login.css'



const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));



function Login(props) {
    const classes = useStyles();

    const { email, setEmail, password, setPassword, handleLogin, handleSignup, hasAccount,
        setHasAccount, emailError, passwordError } = props;


    return (

        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>

                {
                    hasAccount ? <Typography component="h1" variant="h5">Sign Up</Typography>
                        : <Typography component="h1" variant="h5">Sign in</Typography>
                }

                <form className={classes.form} onSubmit={(e) => e.preventDefault()} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        value={email}
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        onChange={e => setEmail(e.target.value)}
                        autoFocus
                    />
                    <p className="errorMsg">{emailError}</p>

                    <br />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        value={password}
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        onChange={e => setPassword(e.target.value)}
                        autoComplete="current-password"
                    />

                    <p className="errorMsg">{passwordError}</p>



                    <div className="btnContainer">
                        {hasAccount ? (
                            <>
                                <Button type="submit" fullWidth variant="contained" color="primary" onClick={handleSignup} className={classes.submit}> Sign Up </Button>
                                <p>Already have an account? <span className="login-span" onClick={() => setHasAccount(!hasAccount)} >Sign in</span> </p>
                            </>
                        ) : (
                            <>
                                <Button type="submit" fullWidth variant="contained" color="primary" onClick={handleLogin} className={classes.submit}> Sign In </Button>
                                <p>Dont have an account? <span className="login-span" onClick={() => setHasAccount(!hasAccount)} >Sign up</span> </p>
                            </>
                        )
                        }
                    </div>


                </form>
            </div>
            <Box mt={8}>

            </Box>
        </Container>
    );
}

export default Login;














// import React from 'react'

// function Login(props) {

//     const { email, setEmail,
//         password,
//         setPassword,
//         handleLogin,
//         handleSignup,
//         hasAccount,
//         setHasAccount,
//         emailError,
//         passwordError }
//         = props;

//     return (
//         <section className="login" >
//             <div className="loginContainer">
//                 <label>Username</label>
//                 <input type="text" autoFocus required value={email}
//                     onChange={e => setEmail(e.target.value)}
//                 />

//                 <p className="errorMsg">{emailError}</p>

//                 <label>Password</label>
//                 <input type="password" required value={password}
//                     onChange={e => setPassword(e.target.value)}
//                 />

//                 <p className="errorMsg">{passwordError}</p>

//                 <div className="btnContainer">
//                     {hasAccount ? (
//                         <>
//                             <button onClick={handleLogin} >Sign in</button>
//                             <p>Dont have an account? <span onClick={() => setHasAccount(!hasAccount)} >Sign up</span> </p>
//                         </>
//                     ) : (
//                         <>
//                             <button onClick={handleSignup} >Sign up</button>
//                             <p> Have an account? <span onClick={() => setHasAccount(!hasAccount)} >Sign in</span> </p>

//                         </>
//                     )
//                     }
//                 </div>

//             </div>
//         </section>
//     )
// }

// export default Login
